module.exports = __webpack_public_path__ + "img/img2.36b22f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/img2.png
// module id = 394
// module chunks = 0